import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGD: CultureInfo = {
  name: 'es-GD',
  displayName: 'español (Granada)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GD',
  parent: CultureInfoEs
};
